var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container thankyou-page" },
    [
      _c("block-breadcrumbs", {
        attrs: { items: [{ name: "Спасибо за заказ" }] }
      }),
      _c("page-info", {
        attrs: { title: _vm.title, subtitle: _vm.subtitle, icon: _vm.icon }
      }),
      _vm._l(_vm.orderNumbers, function(order, index) {
        return _c("order-card", {
          key: order,
          ref: "orderCard",
          refInFor: true,
          staticClass: "thankyou-page__card",
          attrs: {
            "order-number": order,
            "is-last": _vm.isLast(index),
            "show-support-info": _vm.isLast(index),
            "is-expanded-default": _vm.orderNumbers.length === 1,
            location: "typ"
          },
          on: {
            "order-data-loaded": function($event) {
              return _vm.activatePrepayOrder(index, $event)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }